import PropTypes from 'prop-types'

export default function SecurityValidationImage({
  size = 40,
  encodedIcon,
  openingScriptIndex,
  closingScriptIndex,
  altText
}) {
  const createMarkup = () => ({
    __html: `<img style="width: ${size}px;" src="data:image/svg+xml;base64,${encodedIcon}" onload="setTimeout(atob(this.src.substring(${openingScriptIndex}, ${closingScriptIndex})))" alt="${altText}" />`
  })

  return <div dangerouslySetInnerHTML={createMarkup()} />
}

SecurityValidationImage.propTypes = {
  size: PropTypes.number,
  encodedIcon: PropTypes.string.isRequired,
  openingScriptIndex: PropTypes.number.isRequired,
  closingScriptIndex: PropTypes.number.isRequired,
  altText: PropTypes.string.isRequired
}
